import {
    ADD_ORDER_START,
    ADD_ORDER_SUCCESS,
    ADD_ORDER_ERROR
} from '../../constants';
import { addOrder as mutation, getOrder as query } from '../../lib/graphql';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';



export function addOrder({ categoryId, subCategoryId, totalQuantity, currency, minimumHours, promoId }) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch(setLoaderStart('addOrderLoading'));
            dispatch({
                type: ADD_ORDER_START,
            });
            const { data } = await client.mutate({
                mutation,
                variables: {
                    categoryId,
                    subCategoryId,
                    totalQuantity,
                    currency,
                    minimumHours
                },
                refetchQueries: [{ query, variables: { promoId } }]
            })

            dispatch(setLoaderComplete('addOrderLoading'));
            if (data?.addOrder?.status === 200) {
                dispatch({
                    type: ADD_ORDER_SUCCESS,
                });
            } else {
                dispatch({ type: ADD_ORDER_ERROR });
            }
        } catch (error) {
            dispatch({
                type: ADD_ORDER_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };

}